import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import './AppointmentForm.css';

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const timeSlots = [
  "09:00 - 09:30", "09:30 - 10:00", "10:00 - 10:30",
  "10:30 - 11:00", "11:00 - 11:30", "11:30 - 12:00",
  "13:00 - 13:30", "13:30 - 14:00", "14:00 - 14:30",
  "14:30 - 15:00", "15:00 - 15:30", "15:30 - 16:00",
  "16:00 - 16:30", "16:30 - 17:00"
];

const AppointmentForm = () => {
  const [searchParams] = useSearchParams();

  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    date: '',
    time: '',
    message: ''
  });

  const [availableTimes, setAvailableTimes] = useState([]);
  const [takenTimes, setTakenTimes] = useState([]);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const presetDate = searchParams.get('date');
    const presetTime = searchParams.get('time');
    setFormData((prev) => ({
      ...prev,
      date: presetDate || '',
      time: presetTime ? `${presetTime} - ${add30Minutes(presetTime)}` : ''
    }));
  }, []);

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    if (formData.date && formData.date < today) {
      setError("Geçmiş tarihlerde randevu oluşturulamaz.");
    } else {
      setError('');
    }
  }, [formData.date]);

  useEffect(() => {
    if (formData.date) {
      axios.get(`${apiUrl}/api/appointments?date=${formData.date}`)
        .then((res) => {
          const taken = res.data.map(appt => appt.time);
          setTakenTimes(taken);
        })
        .catch(() => setTakenTimes([]));
    }
  }, [formData.date]);

  useEffect(() => {
    const available = timeSlots.filter(t => !takenTimes.includes(t.split(' - ')[0]));
    setAvailableTimes(available);
    if (!available.includes(formData.time)) {
      setFormData((prev) => ({ ...prev, time: '' }));
    }
  }, [takenTimes]);

  const add30Minutes = (time) => {
    const [hour, minute] = time.split(':').map(Number);
    const date = new Date();
    date.setHours(hour, minute + 30, 0, 0);
    return date.toTimeString().slice(0, 5);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (e) => {
    const input = e.target.value.replace(/[^0-9]/g, '');
    let formattedInput = '';
    if (input.length > 0) formattedInput += '0';
    if (input.length > 1) formattedInput += input.substring(1, Math.min(4, input.length));
    if (input.length > 4) formattedInput += ' ' + input.substring(4, Math.min(7, input.length));
    if (input.length > 7) formattedInput += ' ' + input.substring(7, Math.min(9, input.length));
    if (input.length > 9) formattedInput += ' ' + input.substring(9, 11);

    setFormData((prev) => ({ ...prev, phone: formattedInput }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (error) return;

    const phonePattern = /^0\d{10}$/;
    if (!phonePattern.test(formData.phone.replace(/\s/g, ''))) {
      alert("Lütfen geçerli bir 11 haneli telefon numarası girin. (Örnek: 05XX XXX XX XX)");
      return;
    }

    const newAppointment = {
      ...formData,
      phone: formData.phone.replace(/\s/g, ''), // boşlukları kaldır
      time: formData.time.split(' - ')[0]
    };
    

    try {
      await axios.post(`${apiUrl}/api/appointments`, newAppointment);
      setSuccessMessage("Randevu başarıyla oluşturuldu!");
      setFormData({ fullName: '', phone: '', email: '', date: '', time: '', message: '' });
    } catch {
      alert("Randevu oluşturulamadı!");
    }
  };

  return (
    <div className="appointment-form">
      <h2>Randevu Oluştur</h2>

      <form onSubmit={handleSubmit}>
        {successMessage && <p className="success-message">{successMessage}</p>}
        {error && <p className="error-message">{error}</p>}

        <div className="form-group">
          <label>Ad Soyad</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
            placeholder="Adınızı ve soyadınızı giriniz"
          />
        </div>
        <div className="form-group">
        <label htmlFor="phone" >Telefon Numarası</label>
        <input
          type="tel"
          id="phone"
          value={formData.phone}
          onChange={handlePhoneChange}
          required
          placeholder="(Örnek: 05XX XXX XX XX)"
        />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="ornek@mail.com"
          />
        </div>

        <div className="form-group">
          <label>Tarih</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Saat</label>
          <select
            name="time"
            value={formData.time}
            onChange={handleChange}
            required
            disabled={!formData.date || error}
          >
            <option value="">Saat seçiniz</option>
            {availableTimes.length > 0 ? (
              availableTimes.map((t) => <option key={t} value={t}>{t}</option>)
            ) : (
              <option disabled>Tüm saatler dolu</option>
            )}
          </select>
        </div>

        <div className="form-group">
          <label>Mesaj (isteğe bağlı)</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows={3}
            placeholder="Ek bilgi yazabilirsiniz"
          />
        </div>

        <button type="submit">Randevuyu Kaydet</button>
      </form>
    </div>
  );
};

export default AppointmentForm;
